module.exports = __webpack_public_path__ + "img/covid19.d375e35f.png";